<template>
  <v-container>
    <h4 class="mb-5 mt-5">Pilih metode pembayaran</h4>
    <v-card class="mx-auto mb-5" outlined>
      <v-list rounded>
        <v-skeleton-loader
          type="list-item-avatar-two-line@5"
          :loading="loading"
        >
          <v-list-item-group color="primary" v-model="selectedItem">
            <v-subheader>Dikonfirmasi Manual</v-subheader>
            <v-list-item
              v-for="(item, i) in paymentMethods"
              :key="i"
              :value="item.id"
            >
              <v-list-item-avatar>
                <v-img :src="item.bank_logo" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.bank_name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--            <v-subheader>Konfirmasi Otomatis</v-subheader>-->
            <!--            <v-list-item value="0">-->
            <!--              <v-list-item-avatar>-->
            <!--                <v-icon class="blue lighten-1" dark> credit_card </v-icon>-->
            <!--              </v-list-item-avatar>-->
            <!--              <v-list-item-content>-->
            <!--                <v-list-item-title>Payment Gateway</v-list-item-title>-->
            <!--              </v-list-item-content>-->
            <!--            </v-list-item>-->
          </v-list-item-group>
        </v-skeleton-loader>
      </v-list>
      <v-list rounded> </v-list>
    </v-card>

    <v-btn
      large
      block
      color="primary"
      @click="checkoutSubmit"
      :disabled="btnPayState"
      :loading="loadingSubmit"
      >Bayar Sekarang</v-btn
    >

    <v-snackbar v-model="snackbar" :timeout="2000">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'CheckoutPayment',
  data() {
    return {
      selectedItem: null,
      ticket_id: this.$route.params.ticket_id,
      token: 'Bearer ' + localStorage.getItem('token'),
      user: JSON.parse(localStorage.getItem('user')),
      unique_price: localStorage.getItem('unique_price'),
      paymentMethods: [],
      data: [],
      error: null,
      errorMessage: null,
      loading: true,
      loadingSubmit: false,
      btnPayState: true,
      snackbar: false,
      snackbarText: 'Hello',
    };
  },
  mounted() {
    this.loadPaymentMethod();
  },
  methods: {
    loadPaymentMethod() {
      Axios.get(
        process.env.VUE_APP_API + 'checkout/' + this.ticket_id + '/payment',
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          this.paymentMethods = response.data.data.bank_account;
          this.data = response.data.data.ticket;
          // console.log(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },
    checkoutSubmit() {
      this.loadingSubmit = true;
      Axios.post(
        process.env.VUE_APP_API + 'checkout',
        {
          event_ticket_id: this.data.id,
          event_id: this.data.event_id,
          user_id: this.user.id,
          master_payment_method_id: this.selectedItem,
          unique_price: this.unique_price,
        },
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          this.resultCheckout = response.data;
          // console.log(this.resultCheckout);
          if (this.resultCheckout.status == 'success') {
            this.$router.push({
              name: 'CheckoutSuccess',
              query: {
                order_id: this.resultCheckout.transaction_id,
                status_code: '201',
              },
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
          this.snackbarText = 'Terjadi kesalahan sistem';
          this.snackbar = true;
        })
        .finally(() => (this.loadingSubmit = false));
    },
  },
  watch: {
    selectedItem() {
      // console.log(this.selectedItem);
      if (this.selectedItem) {
        this.btnPayState = false;
      } else {
        this.btnPayState = true;
      }
    },
  },
};
</script>

<style scoped></style>
